const AtsMock = {
  retrieveEnvelope() {
    const envelopeVal = window.evite.cookie('_lr_env');
    return envelopeVal || '';
  },
};

export {AtsMock};
